import { Input } from 'antd';
import React, { useState } from 'react';

interface CommonInputFieldProps {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    inputClassName?: string;
    labelClassName?: string;
    required?: boolean;
    prefix?: any;
    type?: string;
    [key: string]: any;
}

const CommonInputField: React.FC<CommonInputFieldProps> = ({
    label,
    placeholder = '',
    value,
    onChange,
    className = '',
    inputClassName = '',
    labelClassName = '',
    required = false,
    prefix,
    type = 'text',
    ...rest
}) => {
    const [error, setError] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newValue = e.target.value;


     
        // Phone number validation (Allow only numbers)
        if (type === 'phone' || type === 'number') {
            newValue = newValue.replace(/\D/g, ''); // Remove non-numeric characters
            if (onChange) {
                e.target.value = newValue;
                onChange(e);
            }
            return; // Stop further processing to prevent invalid characters
        }
        // Validate website URL if type is 'url'
        if (type === 'url') {
            const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
            if (newValue && !urlRegex.test(newValue)) {
                setError('Invalid website URL');
            } else {
                setError(null);
            }
        }

        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div className={`w-full ${className}`}>
            {label && (
                <label className={`block common-label pb-[6px] ${labelClassName}`}>
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <Input

                type={type === 'phone' || type === 'number' ? 'text' : type}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                className={`w-full cursor-pointer h-[42px] ${inputClassName}`}
                prefix={prefix}
                {...rest}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
    );
};

export default CommonInputField;
